/**
 * トップ
 */
import ResizeObserver from 'resize-observer-polyfill';
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID } from '@/_modules/utils/variables';
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalFooter from '@/_components/global-footer.vue';
import GlobalNavi from '@/_components/global-navi.vue';

window.$scrollManager = null;

export default class AppTop {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppTop';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        GlobalHeader,
        GlobalFooter,
        GlobalNavi
      },
      data() {
        return {
          params: {},
          ispc: false,
          isLoaded: false,
          isState: '',
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {
        this.isTiker = document.getElementById('c-tickerSp') ? true : false;
        this.params = JSON.parse(document.getElementById('js-param-top').textContent);
        this.ticker = this.params.ticker_news;

        /*
        this.resize();
        window.addEventListener('resize', this.resize);
        window.addEventListener('scroll', this.handleScroll);
        */

        this.$nextTick(this.start);
      },
      methods: {
        start() {
          // オブザーバインスタンスを作成
          this.observer = new ResizeObserver(this.resize);
          this.observer.observe(document.querySelector('.top_nav'));

          this.resize();
          window.addEventListener('resize', this.resize.bind(this));

          this.mvStart();
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        },
        mvStart() {
          // 初回サイトアクセス判定
          this.isFirst = (document.referrer.indexOf(location.protocol + '//' + location.hostname) === -1);

          /**
           @params
           1. scope
           2. callback関数
           3.
           true => メニューボタンを出すタイミングでcallback実行 トップページから開始（演出あり)
           false => トップページが表示完了できたタイミングでcallback実行 下層ページから遷移してきた（演出なし）
           4. 背景動画のパス
           5. IE用背景画像のパス
           */
          window.tokyo.pics.start(
            this,
            this.completeHeroHandler,
            this.isFirst,
            this.params.video,
            this.params.ie_img
          );
        },
        completeHeroHandler() {
          if (this.isFirst) {
            this.$refs['GlobalHeader'].showUI();
            this.$refs['GlobalFooter'].showUI();
          } else {
            this.$store.commit('setShowCoverOut', false);
          }
        },
        resize() {
          if (window.innerWidth > breakpoint) {
            this.ispc = true;
            document.getElementById('p-top__wrap').style.height = '';
          } else {
            this.ispc = false;
            let tickerH = 0;
            if (this.isTiker) {
              tickerH = (80 / 750) * window.innerWidth;
            }
            const rect = document.querySelector('.top_nav').getBoundingClientRect()
            document.getElementById('p-top__wrap').style.height = (tickerH + rect.y + rect.height) + 'px';
          }
        }
      }
    });
  }
}
